import React from 'react'
import mapPlaceHolder from './map-placeholder-mobile.webp'
import mapPlaceHolderDesk from './map-placeholder.webp'

export default function Page({ height, marginTop, isMobile }) {
  return (
    <div
      style={{
        height,
        marginTop,
        backgroundImage: `url("${isMobile ? mapPlaceHolder : mapPlaceHolderDesk}")`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
      data-cy="map-placeholder"
    />
  )
}
